import { formatMoney } from '@/platform/lib/utils';
import {
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';

const countFormatter = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 0,
});

const formatCount = value => countFormatter.format(value || 0);

const ReportTable = ({ title, rows }) => {
    if (!rows || rows.length === 0) {
        return null;
    }

    const items = rows.slice(0, -1);
    const total = rows.at(-1);
    const hasAmount = items[0]?.amount !== undefined;

    const value = row =>
        hasAmount ? formatMoney(row.value || 0) : formatCount(row.value);

    return (
        <Table striped>
            <TableHeader>
                <TableRow>
                    <TableHeaderCell>{title}</TableHeaderCell>
                    {hasAmount && (
                        <TableHeaderCell collapsing textAlign='right'>
                            #
                        </TableHeaderCell>
                    )}
                    <TableHeaderCell collapsing textAlign='right'>
                        {hasAmount ? '€' : '#'}
                    </TableHeaderCell>
                </TableRow>
            </TableHeader>
            <TableBody>
                {items.map(row => (
                    <TableRow key={row.label}>
                        <TableCell>{row.label}</TableCell>
                        {hasAmount && (
                            <TableCell collapsing textAlign='right'>
                                {formatCount(row.amount)}
                            </TableCell>
                        )}
                        <TableCell collapsing textAlign='right'>
                            {value(row)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell>{total.label}</TableCell>
                    {hasAmount && (
                        <TableCell collapsing textAlign='right'>
                            {formatCount(total.amount)}
                        </TableCell>
                    )}
                    <TableCell collapsing textAlign='right'>
                        {value(total)}
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    );
};

export default ReportTable;
